export default {
  "content": "<path d=\"M9 1v5h5M9 1l5 5M9 1H2v14h12V6m-8 5h4\" stroke=\"#ff00cb\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "width": "16",
    "height": "16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};